"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.IconButton = exports.SelectedWrapper = exports.SelectWrapper = exports.DefaultOptionElementWrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _utils = require("@staccx/utils");

var _Label = _interopRequireDefault(require("../Label/Label"));

var _Input = _interopRequireDefault(require("../Input/Input"));

var _Caret = _interopRequireDefault(require("../../Icons/Caret"));

var _Select = _interopRequireDefault(require("./Select.Option"));

var _Select2 = _interopRequireDefault(require("./Select2"));

var _ThemeComponent = _interopRequireDefault(require("../../Theme/ThemeComponent"));

var _theming = require("../../../theming");

var _Select3 = _interopRequireDefault(require("./Select.themeProps"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CaretComp = function CaretComp(_ref) {
  var props = _extends({}, _ref);

  return _react["default"].createElement(_ThemeComponent["default"], _extends({
    tagName: _Select3["default"].iconComponent,
    fallback: _Caret["default"]
  }, props));
};

var CaretIcon = (0, _styledComponents["default"])(CaretComp).withConfig({
  displayName: "Select__CaretIcon",
  componentId: "zrswg6-0"
})(["transition:transform 0.3s ease-out;transform:", ";"], function (p) {
  return p.isExpanded ? "rotate(180deg)" : "rotate(0)";
});

var Select =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Select, _React$PureComponent);

  function Select(props, context) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props, context));
    _this.state = {
      filter: null,
      selected: _this.props.selectedItem ? _this.props.selectedItem : !_this.props.combobox ? _this.props.placeHolderLabel ? _this.props.placeHolderLabel : _this.props.items[0] : null
    };
    _this.setFilter = _this.setFilter.bind(_assertThisInitialized(_this));
    _this.filterItem = _this.filterItem.bind(_assertThisInitialized(_this));
    _this.handleSelect = _this.handleSelect.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Select, [{
    key: "handleSelect",
    value: function handleSelect(selected) {
      this.setState({
        selected: selected
      });
    }
  }, {
    key: "setFilter",
    value: function setFilter(filter) {
      this.setState({
        filter: filter
      });
    }
  }, {
    key: "filterItem",
    value: function filterItem(item) {
      var filter = this.state.filter;
      var filterProp = this.props.filterProp;
      var field = filterProp ? item[filterProp] : item;
      return filter ? (0, _utils.stringIncludes)(field, filter) : true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onChange = _this$props.onChange,
          placeHolderLabel = _this$props.placeHolderLabel,
          itemToString = _this$props.itemToString,
          className = _this$props.className,
          variant = _this$props.variant,
          items = _this$props.items,
          initialSelectedItem = _this$props.initialSelectedItem;
      var Option = this.props.Option;
      var Selected = this.props.Selected || Option;

      var toString = function toString(item) {
        if (!item) {
          return "";
        }

        if (!placeHolderLabel || item !== placeHolderLabel) {
          return itemToString(item);
        }

        return placeHolderLabel;
      };

      var renderSelected = function renderSelected(selectedItem, getToggleButtonProps, _ref2) {
        var isOpen = _ref2.isOpen;
        return _react["default"].createElement(SelectWrapper, {
          className: className,
          variant: variant
        }, _this2.props.label && _react["default"].createElement(_Label["default"], {
          variant: variant
        }, _this2.props.label), _react["default"].createElement(SelectedWrapper, {
          variant: variant,
          isSelected: true
        }, _this2.props.renderSelected ? _this2.props.renderSelected({
          selectedItem: selectedItem,
          getToggleButtonProps: getToggleButtonProps
        }) : _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(Selected, _extends({}, getToggleButtonProps(), {
          selectedItem: selectedItem,
          variant: variant,
          isSelected: true
        }), toString(selectedItem)), _react["default"].createElement(IconButton, _extends({}, getToggleButtonProps(), {
          variant: variant,
          type: "button",
          tabIndex: -1,
          isSelected: true
        }), _react["default"].createElement(CaretIcon, {
          isExpanded: isOpen,
          variant: variant
        })))));
      };

      var renderPlaceholder = function renderPlaceholder(getToggleButtonProps) {
        return _react["default"].createElement(SelectWrapper, {
          className: className,
          variant: variant
        }, _this2.props.label && _react["default"].createElement(_Label["default"], {
          variant: variant
        }, _this2.props.label), _react["default"].createElement(SelectedWrapper, {
          variant: variant,
          isSelected: true
        }, _react["default"].createElement(Selected, _extends({}, getToggleButtonProps(), {
          selectedItem: placeHolderLabel,
          variant: variant,
          isSelected: true
        }), toString(placeHolderLabel)), _react["default"].createElement(IconButton, _extends({}, getToggleButtonProps(), {
          variant: variant,
          type: "button",
          isSelected: true,
          tabIndex: -1
        }), _react["default"].createElement(CaretIcon, {
          isExpanded: false,
          variant: variant
        }))));
      };

      return _react["default"].createElement(_Select2["default"], {
        options: items,
        renderSelected: renderSelected,
        renderPlaceholder: renderPlaceholder,
        renderLabel: function renderLabel() {
          return null;
        },
        onChange: onChange,
        downshiftProps: {
          initialSelectedItem: initialSelectedItem
        }
      }, function (_ref3) {
        var options = _ref3.options,
            getItemProps = _ref3.getItemProps,
            selectedItem = _ref3.selectedItem,
            highlightedIndex = _ref3.highlightedIndex,
            toggleMenu = _ref3.toggleMenu;
        return _react["default"].createElement(DefaultOptionElementWrapper, {
          variant: variant
        }, options.filter(function (item) {
          return selectedItem ? item : _this2.filterItem(item);
        }).slice(0, _this2.props.maxItems === -1 ? _this2.props.items.length : _this2.props.maxItems).map(function (item, index) {
          if (_this2.props.children) {
            return _this2.props.children({
              item: item,
              getItemProps: getItemProps,
              highlighted: highlightedIndex === index,
              selected: selectedItem === item,
              reset: toggleMenu
            });
          }

          return _react["default"].createElement(SelectItem, _extends({
            variant: variant,
            key: _this2.props.itemToKey(item),
            isSelected: highlightedIndex === index
          }, getItemProps({
            item: item
          })), toString(item));
        }));
      });
    }
  }]);

  return Select;
}(_react["default"].PureComponent);

var SelectItem = _styledComponents["default"].li.withConfig({
  displayName: "Select__SelectItem",
  componentId: "zrswg6-1"
})(["list-style:none;padding:", " ", ";background-color:", ";color:", ";border-bottom:1px solid ", ";&:first-child{border-top:1px solid ", ";}"], _theming.spacing.small, _theming.spacing.medium, function (p) {
  return p.isSelected ? _theming.color.primary : "transparent";
}, function (p) {
  return p.isSelected ? _theming.color.white : _theming.color.black;
}, _theming.color.line, _theming.color.line);

var DefaultOptionElementWrapper = _styledComponents["default"].ul.withConfig({
  displayName: "Select__DefaultOptionElementWrapper",
  componentId: "zrswg6-2"
})(["position:absolute;max-height:300px;overflow:auto;width:100%;cursor:pointer;list-style-type:none;padding:0;margin:0;border:1px solid ", ";background-color:", ";border-top-width:0;z-index:10;> *:not(:last-child){border-bottom:1px solid ", ";}", ";"], _theming.color.line, _theming.color.white, _theming.color.line, (0, _theming.applyVariants)(_Select3["default"].defaultOptionWrapper));

exports.DefaultOptionElementWrapper = DefaultOptionElementWrapper;

var SelectWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Select__SelectWrapper",
  componentId: "zrswg6-3"
})(["position:relative;", ";"], (0, _theming.applyVariants)(_Select3["default"].selectWrapper));

exports.SelectWrapper = SelectWrapper;

var SelectedWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Select__SelectedWrapper",
  componentId: "zrswg6-4"
})(["position:relative;", ";", ";"], function (p) {
  return !p.combobox && (0, _styledComponents.css)(["border:1px solid ", ";border-radius:", ";"], _theming.color.line, _theming.borderRadius);
}, (0, _theming.applyVariants)(_Select3["default"].selectedWrapper));

exports.SelectedWrapper = SelectedWrapper;

var IconButton = _styledComponents["default"].button.withConfig({
  displayName: "Select__IconButton",
  componentId: "zrswg6-5"
})(["position:absolute;right:3px;bottom:50%;width:", ";height:", ";border:0;padding:0 ", ";text-align:center;background-color:transparent;fill:", ";transform:translateY(50%);transition:fill 0.2s ease;&:active,&:hover,&:focus{outline:none;svg{fill:", ";}}", ";"], _theming.targetSize.small, _theming.targetSize.small, _theming.spacing.tiny, _theming.color.wcag, _theming.color.primary, (0, _theming.applyVariants)(_Select3["default"].iconButton));

exports.IconButton = IconButton;
Select.propTypes = {
  Option: _propTypes["default"].any,
  OptionsWrapper: _propTypes["default"].any,
  Placeholder: _propTypes["default"].any,
  Selected: _propTypes["default"].any,
  children: _propTypes["default"].func,
  className: _propTypes["default"].string,
  combobox: _propTypes["default"].bool,
  filterProp: _propTypes["default"].string,
  itemToKey: _propTypes["default"].any,
  itemToString: _propTypes["default"].func,
  items: _propTypes["default"].array.isRequired,
  label: _propTypes["default"].string,
  mapKey: _propTypes["default"].func,
  mapSelected: _propTypes["default"].func,
  maxItems: _propTypes["default"].number,
  onChange: _propTypes["default"].func,
  placeHolderLabel: _propTypes["default"].any,
  renderSelected: _propTypes["default"].func,
  selectedItem: _propTypes["default"].any,
  variant: _propTypes["default"].string
};
Select.defaultProps = {
  Option: _Select["default"],
  OptionsWrapper: DefaultOptionElementWrapper,
  Placeholder: _Input["default"],
  combobox: false,
  itemToKey: function itemToKey(item) {
    return item;
  },
  itemToString: function itemToString(item) {
    return item;
  },
  maxItems: -1
};
Select.themeProps = _Select3["default"];
var _default = Select;
exports["default"] = _default;